import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./LoginLayout.styles";
import Login from "../../modules/login/Login";
import UserService from '../../common/services/user.service';
import CircularBox from "../../common/components/circular-box/CircularBox";

const LoginLayout = () => {
  const [isLoading, setIsLoading] = useState(UserService.loading);
  const navigate = useNavigate();

  useEffect(()=> {
    if (isLoading) {
      setTimeout(() => {
        UserService.loadOut();
        setIsLoading(UserService.loading)
      }, 1000);
    }
    if (!isLoading) {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <Box sx={styles.layoutWrapper}>
      <Box component="main" sx={styles.main}>
        {isLoading ? <CircularBox /> : <Login />}
      </Box>
    </Box>
  );
};

export default LoginLayout;
